import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_2 = {
  style: {
    "text-align": "center"
  }
};
import { acceptInviteInviteId } from '@/request/index.ts';
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import { useRouter } from "vue-router";
export default {
  __name: 'inviteCardPack',
  props: {
    inviteId: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    const props = __props;
    const router = useRouter();
    let goAcceptInviteInviteId = () => {
      if (!props.inviteId) {
        ElMessage.warning('邀请链接无效');
        return;
      }
      acceptInviteInviteId(props.inviteId).then(res => {
        var _res$data;
        if (((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === 200) {
          ElMessage.success('领取成功');
          setTimeout(() => {
            router.push('/work-plateform');
          }, 1000);
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createBlock(_component_el_card, {
        style: {
          "min-width": "480px"
        },
        shadow: "never"
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          onClick: _unref(goAcceptInviteInviteId)
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("领取")])),
          _: 1
        }, 8, ["onClick"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_image, {
          src: require('@/assets/images/card-case.png')
        }, null, 8, ["src"]), _cache[0] || (_cache[0] = _createElementVNode("p", null, "惊喜连连，专属于您的神秘福利！", -1)), _cache[1] || (_cache[1] = _createElementVNode("p", null, "解锁未知惊喜，让每一次探索都充满期待。", -1)), _cache[2] || (_cache[2] = _createElementVNode("div", {
          style: {
            "font-size": "12px"
          }
        }, [_createElementVNode("p", {
          style: {
            "color": "#8D9095"
          }
        }, " 快速开启您的惊喜吧 ~ ")], -1))])]),
        _: 1
      });
    };
  }
};